import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageProvider";

const ensureMeta = (selector, attribute, value) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    const [name, propertyValue] = attribute;
    element.setAttribute(name, propertyValue);
    document.head.appendChild(element);
  }

  element.setAttribute("content", value);
};

const PageMeta = ({
  title,
  description,
  image = "https://wonyaso.com/wonsod.png",
  imageAlt = "WonyaSoft",
}) => {
  const { pathname } = useLocation();
  const { language, t } = useLanguage();

  useEffect(() => {
    const translatedTitle = t(title);
    const translatedDescription = t(description);
    const canonicalUrl = `https://wonyaso.com${pathname === "/" ? "" : pathname}`;

    document.title = translatedTitle;
    ensureMeta(
      'meta[name="description"]',
      ["name", "description"],
      translatedDescription,
    );
    ensureMeta(
      'meta[property="og:title"]',
      ["property", "og:title"],
      translatedTitle,
    );
    ensureMeta(
      'meta[property="og:description"]',
      ["property", "og:description"],
      translatedDescription,
    );
    ensureMeta('meta[property="og:url"]', ["property", "og:url"], canonicalUrl);
    ensureMeta(
      'meta[property="og:locale"]',
      ["property", "og:locale"],
      language === "en" ? "en_US" : "fr_CD",
    );
    ensureMeta('meta[property="og:image"]', ["property", "og:image"], image);
    ensureMeta(
      'meta[property="og:image:alt"]',
      ["property", "og:image:alt"],
      t(imageAlt),
    );
    ensureMeta('meta[property="og:type"]', ["property", "og:type"], "website");
    ensureMeta(
      'meta[name="twitter:card"]',
      ["name", "twitter:card"],
      "summary_large_image",
    );
    ensureMeta(
      'meta[name="twitter:title"]',
      ["name", "twitter:title"],
      translatedTitle,
    );
    ensureMeta(
      'meta[name="twitter:description"]',
      ["name", "twitter:description"],
      translatedDescription,
    );
    ensureMeta('meta[name="twitter:image"]', ["name", "twitter:image"], image);
    ensureMeta(
      'meta[name="twitter:image:alt"]',
      ["name", "twitter:image:alt"],
      t(imageAlt),
    );

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);
  }, [description, image, imageAlt, language, pathname, t, title]);

  return null;
};

export default PageMeta;
